import { Button, Form, Modal, ModalProps } from "antd";
import { cloneElement, ReactNode, useState } from "react";
import { TypeAluno } from "../../../../../Models/Domain/Pessoa/Aluno";
import { CadastroDeAluno, IFormularioDeCadastroDeAluno } from "../../../../../Views/Viagem/Cadastros/Viagem/Componentes/CadastroDeAluno";

export interface IAlunoModalForm extends ModalProps {
    buttonOpen?:ReactNode;
    aluno?:TypeAluno|null;
    onChange?:(aluno:TypeAluno|null) => void;
    onOpen?:() => void;
}
export default function AlunoModalFormChange({
    title,
    width,
    cancelButtonProps,
    buttonOpen,
    onOpen,
    onChange,
    aluno,
    ...rest
}:IAlunoModalForm) {
    const [ aberta, setAberta ] = useState(false);
    const form = Form.useForm<IFormularioDeCadastroDeAluno>();
    const formulario = form[0];

    function abrirModal() {
        setAberta(true);
        onOpen?.();
    }

    function fecharModal() {
        formulario.resetFields();
        setAberta(false);
    }
    
    return <>
        {
            buttonOpen 
            && cloneElement(buttonOpen as React.ReactElement<any>, { onClick : abrirModal }) 
            || <Button type="primary" size="small" onClick={abrirModal}>Adicionar novo aluno</Button>
        }
        <Modal
            {...rest}
            open={aberta}
            title={title ?? "Cadastrar novo aluno"}
            width={width ?? "90vw"}
            onOk={formulario.submit}
            onCancel={fecharModal}
            destroyOnClose
            cancelButtonProps={{
                danger : true,
                ...cancelButtonProps
            }}
        >
            <CadastroDeAluno
                privilegio='responsavel'
                alunoEmAlteracao={aluno ?? undefined}
                formParam={form}
                persistirDados={false}
                onFinish={(aluno) => {
                    onChange?.(aluno);
                    fecharModal();
                }}
            />
        </Modal>
    </> 
}